import Stardog from 'stardog';

import { Permission } from 'src/constants/permissions';

export type MatchResourceFn = (
  permissionResource: string,
  targetResource: string
) => boolean;

const defaultMatchResource: MatchResourceFn = (
  permissionResource,
  targetResource
) => permissionResource === targetResource;

export const hasPermission = (
  permissions: Permission[],
  action: Stardog.user.Action,
  resourceType: Stardog.user.ResourceType,
  resource: string,
  matchResource: MatchResourceFn = defaultMatchResource
) =>
  permissions.some((permission) => {
    const hasAction =
      permission.action === 'ALL' || permission.action === action;
    const hasResourceType =
      permission.resource_type === '*' ||
      permission.resource_type === resourceType;
    const hasResource = permission.resource.some(
      (res) => res === '*' || matchResource(res, resource)
    );
    return hasAction && hasResourceType && hasResource;
  });

/**
 * Check if user has the given action permission on at least one resource of the given type.
 * Unlike `hasPermission` which checks for a specific resource, this checks if the user
 * has the permission on ANY resource of that type.
 */
export const hasAnyResourcePermission = (
  permissions: Permission[],
  action: Stardog.user.Action,
  resourceType: Stardog.user.ResourceType
): boolean =>
  permissions.some((permission) => {
    const hasAction =
      permission.action === 'ALL' || permission.action === action;
    const hasResourceType =
      permission.resource_type === '*' ||
      permission.resource_type === resourceType;
    const hasAnyResource = permission.resource.length;
    return hasAction && hasResourceType && hasAnyResource;
  });
